












import Vue from 'vue'
import Component from 'vue-class-component'

@Component<BaseIcon>({
  props: {
    width: {
      type: Number,
      default: 18
    },
    height: {
      type: Number,
      default: 18
    },
    fill: {
      type: String,
      default: 'none'
    },
    viewBox: {
      type: String,
      default: '0 0 40 40'
    },
    rotateDeg: {
      type: String,
      default: '0'
    },
    flipH: {
      type: Boolean,
      default: false
    }
  }
})

export default class BaseIcon extends Vue {
  /**
   * Props variables
   */
  width: number | undefined
  height: number | undefined
  fill: string | undefined
  viewBox: string | undefined
  rotateDeg: string | undefined
  flipH: boolean | undefined

  /**
   * Component state variables
   */


  /**
   * Lifecycle
   */

  /**
   * Getters
   */
  get flipMatrix (): string {
    if(this.flipH)
      return 'matrix(-1, 0, 0, 1, 0, 0)'
    return ''
  }


  /**
   * Methods
   */

}
